module.exports = __webpack_public_path__ + "img/zhongxue.39b25452.png";